// extracted by mini-css-extract-plugin
module.exports = {"outline":"outline_outline__3xwnA","main":"outline_main__T2-Ah","side":"outline_side__pPYQ-","slidewrap":"outline_slidewrap__1Hpe0"};